export const toUsFormat = (number = 0, length = 2) => number.toLocaleString('en', { minimumFractionDigits: length });

export const postHeightToParent = (h: number) => {
  console.log("MEASURED HEIGHT ", h);
  const newHeight = Math.floor(h) + 1;
  window.parent.postMessage({ height: newHeight }, "*");
  console.log("MESSAGE POSTED ", newHeight);
}

const isDotOnEnd = (x: string) => {
  return x.charAt(x.length - 1) === '.';
};

export const parseNumber = (string: string) => {
  //remove comas, limit length
  const clearValue = string.replace(/,/g, '').substring(0,12);
  const hasDotOnEnd = isDotOnEnd(clearValue);
  let number: number = Number.parseFloat(clearValue);
  let numberStr: string = number.toString();

  if (hasDotOnEnd) {
    numberStr += '.';
  }

  switch (true) {
    case Number.isNaN(number):
      return '';
    case number < 0:
      return 0;
    default:
      return numberStr;
  }
};

const Formatter = new Intl.NumberFormat('en-US', {
  style: 'decimal',
  minimumFractionDigits: 0,
});

export const formatNumber = (x: string) => {
  if (x === '') {
    return x;
  }

  const hasDotOnEnd = isDotOnEnd(x);
  let formattedNumber = Formatter.format(Number(x));

  if (hasDotOnEnd) {
    formattedNumber += '.';
  }

  return formattedNumber;
};

// used by net worth and retirement savings calcs
export const validAmount = (string: string) => {
  const match = string.replace(/,/g, '').match(/\d+(\.)?(\d{1,2})?/);
  if (!match) { return ''; }
  return match[0] || '';
};

/**
 * Filteres text input value to only allow numbers of length up to two digits
 * @param string text input value
 * @returns matched string value or an empty string
 */
export const validInteger = (string: string) => {
  const match = string.match(/[0-9]{1,2}/);
  if (!match) { return ''; }
  return match[0] || '';
};

export const parseSmallAmount = (string: string, lengthLimit: number = 0) => {
  const blank = lengthLimit === 0 ? validAmount(string) : validAmount(string.substring(0, lengthLimit));

  if (!blank) return '';
  const rest = blank.split('.')[1];

  if (rest === '') return `$${toUsFormat(+blank, 0)}.`;
  let restLength = 0;

  if (rest && rest.length) {restLength = Math.min(rest.length, 2);}
  return `$${toUsFormat(+blank, restLength)}`;
};

export const parseFullAmount = (value: string | number) => {
  const isNegative = value < 0;
  const blank = validAmount(typeof value === 'string' ? value : String(value));

  if (!blank) return '';
  return `${(isNegative ? '-' : '')}$${toUsFormat(+blank)}`;
};
